export const environment = {
  production: true,
  host: 'app.ildes.co',
  appHost: 'app.ildes.co',
  port: '3000',
  protocol: 'https',
  releaseDate: '1/6/2025, 20:34:49',
  sentryApiKey: 'https://fab4d9e8e94daa525fe33136ee654514@o4507115044339712.ingest.de.sentry.io/4507120584097872',
  releaseVersion: '4.3.1',
  recaptchaSiteKey: '6LeJoFsrAAAAAOc8ARNvTRJTYS-8N3JMXQlxCIyN',
};
